/* @flow */
import { useMutation, type MutationResult } from 'react-query';
import useClientId from 'common/hooks/useClientId';
import { status as statusApi } from 'platform/api';

type Params = {
    status: string,
    reason: string
};

export const useUpdateStatus = (): MutationResult<Params, void> => {
    const clientId = useClientId();
    return useMutation(async ({ status, reason }: Params) => {
        return await statusApi.post({ clientId }, { status, reason });
    });
};
